import React from 'react'

const EquipmentTopBar = (props) => {
    return (
        <div id="component-topbar" className={props.className} style={{backgroundColor: props.color}}>
            <div style={{ margin: 'auto', width: '95%' }}>
              {props.buttons}
            </div>
        </div>
    )
}

export default EquipmentTopBar;
